import * as React from 'react'
import { useFormContext } from 'react-hook-form'
import { Switch } from '../ui/switch'
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '../ui/form'

export default function SwitchField({ label, name, disabled }: { label: string, name: string, disabled?: boolean }) {
    const form = useFormContext()
    return (
        <FormField
            control={form.control}
            name={name}
            render={({ field }) => (
                <FormItem className='flex items-center gap-2'>
                    <FormLabel htmlFor={name}>{label}</FormLabel>
                    <FormControl>
                        <Switch id={name} checked={!!field.value} onCheckedChange={field.onChange} disabled={disabled} />
                    </FormControl>
                    <FormMessage />
                </FormItem>
            )}
        />
    )
}
